import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { RowStyle } from '@website-builder/model/structure/row/row-style';
import { Column } from '@website-builder/model/structure/column/column';
import { EditableComponent } from '@website-builder/model/structure/editable-component.interface';
import { BuilderElementPosition } from '@website-builder/model/structure/builder-element-position';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { LayoutRegistry } from '@website-builder/model/structure/layout-registry/layout-registry';
import { ColumnLayout } from '@website-builder/model/structure/column/column-layout';
import { StyleBreakPoint } from '@website-builder/model/structure/breakpoint.enum';

export class Row implements EditableComponent {
  readonly type: BuilderElementType.Row = BuilderElementType.Row;
  builderElementPosition: BuilderElementPosition;
  id = makeEntityId(EntityIdPrefix.ROW);
  originalLayout = new Array<number>();
  columns = new Array<Column>();
  style = new RowStyle();

  static normalizeInPlace(row: Partial<Row>): Row {
    const pureRow = new Row();

    Row.tempNormalizeColumnLayout(row as Row);

    row.id = row.id ?? pureRow.id;
    row.originalLayout = row.originalLayout ?? pureRow.originalLayout;
    row.style = RowStyle.normalize(row.style);

    row.columns = (row.columns ?? []).map(column => Column.normalizeInPlace(column));

    return row as Row;
  }

  static tempNormalizeColumnLayout(row: Row): void {
    const layoutRegistryState = LayoutRegistry.getWebsiteLayout(row.originalLayout);

    row.columns.forEach((column, columnIndex) => {
      if (column.layout) {
        return;
      }
      column.layout = new ColumnLayout();

      const classStyleStr = layoutRegistryState.classes[columnIndex];
      const classStyleArr = classStyleStr.split(' ');

      classStyleArr.forEach(classStyleElement => {
        if (classStyleElement) {
          let breakpoint: StyleBreakPoint | undefined = classStyleElement.split('@')[1] as StyleBreakPoint;

          if (breakpoint) {
            breakpoint = ('@' + breakpoint) as StyleBreakPoint;
            switch (breakpoint) {
              case StyleBreakPoint.SMALL:
                column.layout.phoneLandscape = classStyleElement;
                break;
              case StyleBreakPoint.MIDDLE:
                column.layout.tabletLandscape = classStyleElement;
                break;
              case StyleBreakPoint.LARGE:
                column.layout.desktop = classStyleElement;
                break;
              case StyleBreakPoint.X_LARGE:
                column.layout.largeScreen = classStyleElement;
                break;
            }
          }
        }
      });

      if (!column.layout.phonePortrait.length) {
        column.layout.phonePortrait = 'uk-width-1-1';
      }
    });
  }
}
